import { useFormikContext } from "formik";
import { useDebounceEffect } from "ahooks";
//#region src/components/FormikFields/AutoSubmitFormik.tsx
/** Submits form when any value changes and it's valid */
function AutoSubmitFormik() {
	const { dirty, isValid, submitForm, values } = useFormikContext();
	useDebounceEffect(() => {
		if (isValid && dirty) submitForm();
	}, [
		isValid,
		values,
		dirty,
		submitForm
	], { wait: 500 });
	return null;
}
//#endregion
export { AutoSubmitFormik };

//# sourceMappingURL=AutoSubmitFormik.js.map